<div class="table-responsive">
  <table class="table">
    <tr>
      <th>Document name</th>
      <th>Type</th>
      <th></th>
    </tr>
    @for (application of creditApplications$ | async; track application) {
      <tr>
        <td>{{application.file.name}}</td>
        <td>{{application.type}}</td>
        <td>
          <button mat-icon-button type="button" [matMenuTriggerFor]="creditAppMenu" [matMenuTriggerData]="{application: application, index: $index}">
            <mat-icon class="fa fa-2x fa-ellipsis-v"></mat-icon>
          </button>
        </td>
      </tr>
    }
  </table>
  <button type="button" mat-button class="pull-right" (click)="upload()">
    <i class="fa fa-fw fa-plus"></i> Upload
  </button>
</div>

<mat-menu #creditAppMenu="matMenu" yPosition="below" class="nav-right-menu">
  <ng-template matMenuContent let-application="application" let-index="index">
    <button mat-menu-item type="button" (click)="download(application)">
      <i class="fa fa-fw fa-cloud-arrow-down" aria-hidden="true"></i> Download
    </button>
    <button mat-menu-item type="button" (click)="delete(application)">
      <i class="fa fa-fw fa-trash-can" aria-hidden="true"></i> Delete
    </button>
  </ng-template>
</mat-menu>
